import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgMelasmaGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M38.948 40a.682.682 0 0 1-.681-.663l-.745-25.435c-.073-1.653-.962-3.033-2.488-3.878-1.453-.808-3.178-.88-4.75-.2a5.867 5.867 0 0 0-3.34 3.942l-1.935 7.79 2.851 11.542c.336 1.163.418 2.288.227 3.333-.417 2.27-1.788 3.568-3.777 3.568-1.135 0-2.116-.463-2.833-1.343-.945-1.172-1.317-3.024-.954-4.713l3.079-12.386-1.925-7.782a5.882 5.882 0 0 0-3.342-3.95c-1.562-.681-3.296-.609-4.75.2-.88.49-2.379 1.652-2.478 3.886l-.745 25.426a.687.687 0 0 1-.7.662A.675.675 0 0 1 9 39.3l.745-25.434c.09-2.134 1.253-3.96 3.187-5.031 1.825-1.017 3.995-1.108 5.957-.254a7.266 7.266 0 0 1 4.122 4.867l1.308 5.285 1.317-5.294a7.267 7.267 0 0 1 4.122-4.867c1.962-.854 4.132-.754 5.948.254 1.925 1.071 3.087 2.896 3.187 5.021l.745 25.453a.68.68 0 0 1-.663.7h-.027ZM24.31 24.39l-2.452 9.861c-.272 1.263 0 2.697.69 3.55.454.564 1.045.845 1.77.845 1.644 0 2.226-1.334 2.434-2.451.155-.836.082-1.753-.2-2.734L24.31 24.39Z",
    fill: "currentColor"
  }));
}

export { SvgMelasmaGlyphSecondary as default };
